import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { FormType } from '../Utilities/FormType';
import { AMIGForm, getShowedFields } from '../Utilities/AMIGForm';
import { damage } from '../ScreenObjects/Renter/damaged';
import { setPathValue, setReduxValues, useAMIGFormik } from '../Utilities/AMIGHandleForm';
import { StepTypes, ComponentTitle, FIELD_TYPE, IncidentOwnerTemplate } from '../../../../actions/types';
import { summaryActions } from "../../../../actions/summary";
import { newClaimActions } from "../../../../actions/newClaim";
import { useLoading } from '../../../../hooks/useLoading';
import { LoadingPlaceholder } from '../Utilities/LoadingPlaceholder';
import { Injured } from '../Common/Injured';
import CustomDialog from '../../../dialogs/CustomDialog';
import { updateClaim } from '../../../../actions/claimActions';


const { updateDisabled } = summaryActions;
const { updateDamagedRen } = newClaimActions;

export const DamagedWithRedux = ({ 
  summary, 
  claim,
  newClaim,
  updateDisabled, 
  updateDamagedRen,
  updateClaim,
  stepType, 
  handleNext 
}) => {
  
  const fields = damage;
  const {isLoading, setIsLoading} = useLoading();

  const [showInjured, setShowInjured] = useState(false);

  const handleSubmit = () => {
     
    const selectedDamageFields = fields.filter(field => field.type === FIELD_TYPE.CHECKBOX && formik.values[field.name] === true);
    
    const damageValues = selectedDamageFields.map(i => {
      return {name: i.name, value: formik.values[i.name]}
    });

    const ruleDamaged = damageValues.every( field => {
      
      if((field.name === 'DAMAGE_TO_APT' || field.name === 'UNEMPLOYMENT' || field.name === 'NO_DAMAGE') && field.value) {
        return field.value;
      }
      return !field.value;
    });

    const newValues = {...formik.values, ruleDamaged}
    
    updateDamagedRen(newValues);

    const showedFields = getShowedFields(formik, fields);
    
    const copyClaim = setPathValue(formik, showedFields, claim);
    
    copyClaim.damageType = fields.reduce((acc,cur) =>{
      if(cur.type === FIELD_TYPE.CHECKBOX && formik.values[cur.name]){ 
        return [...acc,cur.name];
      }
      return acc;
    },[]);

    if (formik.values['DAMAGE_TO_APT']) copyClaim.lossCause = 'otherspropertydamage_ext';
    if (formik.values['UNEMPLOYMENT']) copyClaim.lossCause = 'allother_ext';
    if (formik.values['NO_DAMAGE']) copyClaim.lossCause = 'powerOutageEvacuation_ext';
    if (formik.values['DAMAGE_TO_APT'] && !formik.values['information']) {
      copyClaim.contacts.push(IncidentOwnerTemplate)
    }  

    updateClaim(copyClaim);
    if(newValues["SOMEONE_INJURED"]){
      setShowInjured(true);
    } else if(!summary.isLastStept) handleNext();
    else updateDisabled(stepType, true);
  };
  
  const formik = useAMIGFormik(fields, handleSubmit);
    
  useEffect(() => {
    try {
        setReduxValues(formik, newClaim.damagedRen, fields);
        setIsLoading(false);
    } catch(error) {
      console.error("Error",error);
    }
  },[]);

  if(isLoading) return <LoadingPlaceholder />;
  
  return (
    <FormType 
      title={ComponentTitle.DAMAGED}
      subtitle='File a claim'
      buttonLabel={summary.isLastStept ? "Save" :"Continue"}
      isDisable={summary.isStepDisabled(summary.disable, stepType)}
      handleSubmit={formik.handleSubmit}>
      <AMIGForm stepType={stepType} fields={fields} formik={formik} />
      <CustomDialog
        title=''
        maxWidth='xl'
        open={showInjured}
        handleClose={() => setShowInjured(false)}>
        {<Injured stepType={StepTypes.INJURED} handleNext={handleNext}/>}
      </CustomDialog>
    </FormType>
  );
};

DamagedWithRedux.defaultProps = {
  stepType: StepTypes.DAMAGED_REN, 
  handleNext: () => {},
};

const mapStateToProps = (state) => ({
  summary: state.summary,
  claim: state.claim,
  newClaim: state.newClaim,
});

export const Damaged = connect(mapStateToProps, { updateDisabled, updateDamagedRen, updateClaim })(DamagedWithRedux);
